<div class="wrapper" [class.particle-background]="showLayoutWithContentInTheMiddle">
  <div class="container">
    @if(!showLayoutWithContentInTheMiddle) {
      <ng-container tabindex="-1" aria-hidden="true">
        <div class="left-column scroll">
          <div class="layout-column navigation-bar p-24">
            <div class="sn-logo mb-44"></div>
            @if(showLeftNavigationMenu) {
              <app-left-navigation-menu />
            }
          </div>
        </div>
      </ng-container>
    }
    
    <div siqGrid fx-direction="column" fx-layout-align="space-between" appScrollable 
      class="middle-column" 
      [class.border-left-400]="!showLayoutWithContentInTheMiddle"
      [class.border-right]="!showLayoutWithContentInTheMiddle"
      [class.primary-400]="!showLayoutWithContentInTheMiddle"
      [class.scroll]="!showLayoutWithContentInTheMiddle">
      <div class="content-wrapper">
        <ng-content></ng-content>
        <!-- (siqNotification$ | async) as siqNotification syntax is not supported in @if -->
        <ng-container *ngIf="(siqNotification$ | async) as siqNotification">
          <app-siq-notification
            tabindex="-1"
            class="siq-notification"
            [isSuccess]="siqNotification.isSuccess" 
            [text]="siqNotification.text" />
        </ng-container> 
        @if(showPrivacyModeBanner) {
          <app-siq-privacy-banner tabindex="-1"  class="siq-privacy-banner" />
        }   
      </div>
      @if(!showLayoutWithContentInTheMiddle) {
        <app-info-bar tabindex="-1" class="info-bar-mobile-screen"/>
      }
      @if(showLeftNavigationMenu) {
        <app-left-navigation-menu tabindex="-1" class="navigation-bar-mobile-screen" />
      }
    </div>

    @if(!showLayoutWithContentInTheMiddle) {
      <div tabindex="-1" aria-hidden="true" class="right-column scroll">
        <app-info-bar />
      </div>
    }
  </div>

  @if(showFooter) {
    <div tabindex="-1" aria-hidden="true" class="py-24">
      <app-siq-footer></app-siq-footer>
    </div>
  }
</div>
